import { IMonitoringFormControlsResolver } from './IMonitoringFormControlsResolver';
import { RootContainer, Container, RepeatableContainer, RepeatableSection } from './answerComponents/containers';
import { TextBlock, FormDividingLine, ImageBlock } from './answerComponents/content';
import {
  FormTextInput,
  FormMultipleTextInput,
  FormNumberInput,
  FormSliderInput,
  FormDateInput,
  FormDateRangeInput,
  FormTimeInput,
  FormRadioGroupInput,
  FormDropDownInput,
  FormCheckboxGroupInput,
  FormMultipleDropdownInput,
  FormTagInput,
  FormFileInput,
} from './answerComponents/inputs';

export const monitoringFormsAnswerControlsResolver: IMonitoringFormControlsResolver = {
  // Containers
  RootContainer: RootContainer,
  Container: Container,
  RepeatableContainer: RepeatableContainer,
  RepeatableSection: RepeatableSection,

  // Content
  FormText: TextBlock,
  FormDividingLine: FormDividingLine,
  FormImage: ImageBlock,

  // Inputs
  FormTextInput: FormTextInput,
  FormMultipleTextInput: FormMultipleTextInput,
  FormNumberInput: FormNumberInput,
  FormSliderInput: FormSliderInput,
  FormDateInput: FormDateInput,
  FormDateRangeInput: FormDateRangeInput,
  FormTimeInput: FormTimeInput,
  FormRadioGroupInput: FormRadioGroupInput,
  FormDropdownInput: FormDropDownInput,
  FormCheckboxGroupInput: FormCheckboxGroupInput,
  FormMultipleDropdownInput: FormMultipleDropdownInput,
  FormTagInput: FormTagInput,
  FormFileInput: FormFileInput,
};
